import classes from "./about.module.css";
import LinkIcon from "../../assets/images/techIcons/link.png";
const projects = [
  {
    type: "project",
    title: "Flashy JSON - Live",
    description: [
      "Interactive Graph-Based JSON Visualizer that transforms nested JSON into interactive, draggable node graphs on an infinite canvas.",
      "Built with React 19, TypeScript, and Vite. Features 5 view modes, live search, 4 layout directions, theme customization, and export to SVG/PNG/CSV.",
    ],
    technologies: ["React-19", "TypeScript", "Vite", "Canvas API", "CSS Transforms"],
    githubLink: "https://flashy-json.vercel.app/",
  },
  {
    type: "project",
    title: "Mento.in - Live",
    description: [
      "As a Lead Developer Intern, I drive front-end development using React.js and AWS to create scalable systems.",
      "My responsibilities include designing key features, working with cross-functional teams, and enhancing to boost platform performance, scalability, and overall user experience.",
    ],
    technologies: ["AWS", "React-Js", "JavaScript", "CSS", "SEO", "API"],
    githubLink: "https://mento.in/",
  },
  {
    type: "project",
    title: "Expense Manager - Git",
    duration: "",
    description: [
      "The Expense Manager Web App is your go-to tool for effortlessly managing your monthly expenses.",
      "Created with React.JS and powered by Firebase, it offers a seamless experience to track, analyze, and organize your financial transactions all in one place.",
    ],
    technologies: ["React-Js", "Firebase"],
    githubLink: "https://github.com/Codester06/Expense-Manager",
  },
  {
    type: "project",
    title: "Blog Site - Git",
    duration: "",
    description: [
      "The Simple Blog Site is a user-friendly platform made with React.JS.",
      "It lets you easily write and share blog posts, connect with readers, and explore different topics.",
    ],
    technologies: ["React-Js"],
    githubLink: "https://github.com/Codester06/myblog-page",
  },
  {
    type: "project",
    title: "Notes Maker - Git",
    duration: "",
    description: [
      "The Notes Maker site, powered by React and Vite, simplifies note-taking.",
      "It offers a user-friendly interface to create, store, and manage notes without hassle.",
    ],
    technologies: ["React-Js", "Vite", "Express-Js"],
    githubLink: "https://github.com/Codester06/notes-maker",
  },
  {
    type: "project",
    title: "Auto Meeting Scheduler - Deployed",
    duration: "",
    description: [
      "Effortlessly schedules Google Meet sessions and sends instant email invites — automating your meeting workflow in one click.",
    ],
    technologies: ["React-Js", "Node-Js", "Express-Js"],
    githubLink: "https://auto-meeting-scheduler-two.vercel.app/",
  },
];

const ProjectsCollection = () => {
  return (
    <>
      {projects.map((item, index) => (
        <div key={index} className={classes.cardProject}>
          <div className={classes.cardProjectContainer}>
            <div className={classes.cardProjectTitle}>{item.title}</div>
            {item.description && (
              <div className={classes.ProjectDescription}>
                {item.description.map((desc, descIndex) => (
                  <p key={descIndex}>{desc}</p>
                ))}
              </div>
            )}
            <div className={classes.techIndex}>
              {item.technologies && (
                <div className={classes.ProjectTechnologies}>
                  <p>Technologies used :</p>
                  <div className={classes.ListTech}>
                    {item.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className={classes.techTag}>
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              <div className={classes.LinkTech}>
                <a
                  href={item.githubLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.projectLink}
                >
                  <img className={classes.linkIcon} src={LinkIcon} alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ProjectsCollection;
